import { RefObject, useEffect, useRef } from 'react';

export const useScrollIntoView = (enabled: boolean | undefined = true): { ref: RefObject<HTMLDivElement> } => {
  const ref = useRef<HTMLDivElement>(null);

  const isInViewport = (offset = 0) => {
    if (!ref.current) return true;
    const top = ref.current.getBoundingClientRect().top;
    return top + offset >= 0 && top - offset <= window.innerHeight;
  };

  useEffect(() => {
    if (enabled && !isInViewport()) {
      setTimeout(() => ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 200);
    }
  }, [enabled]);

  return { ref };
};
